module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', {
    staticStyle: {
      "margin-bottom": "10px"
    }
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        _vm.exportData()
      }
    }
  }, [_vm._v("导出最近1000条交易记录")])], 1), _vm._v(" "), _c('xtable', {
    ref: "mytable",
    attrs: {
      "config": _vm.config,
      "data": _vm.data
    },
    on: {
      "clickRowBtn": function($event) {},
      "clickMultiBtn": function($event) {}
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@10.3.0@vue-loader/lib/template-compiler.js?id=data-v-3f195c0e!./~/_vue-loader@10.3.0@vue-loader/lib/selector.js?type=template&index=0!./src/components/store/log_money.vue
// module id = 218
// module chunks = 2